import React from "react";
import { BookStore } from "../../flux";
const gadgetId = "pearson-smart-thinking";
import { ltiLaunch } from "../../../../ui/utils/location";

const launchPearsonSmartThinking = isbn => {
  const roles = Fraction.User.roles
    ? Fraction.User.roles.map(role => role.name).join(",")
    : "";
  const launchParams = {
    isbn: isbn,
    label: "Pearson Smart Thinking",
    lis_person_name_given: Fraction.User.firstName,
    lis_person_name_family: Fraction.User.lastName,
    lis_person_contact_email_primary: Fraction.User.email
  };
  ltiLaunch(Fraction.User, "pearson_st", true, roles, launchParams);
};

const isEnabled = isbn => {
  const book = BookStore.get(isbn);
  const pearsonFeatureFlag =
    book.features &&
    book.features.find(
      f => f.name.toLowerCase().indexOf("pearsonsmartthinking") !== -1
    );
  return Fraction.Brand.PearsonSmartThinking.enabled && pearsonFeatureFlag;
};

module.exports = {
  metadata: () => ({
    id: gadgetId,
    name: "Pearson Smart Thinking",
    learnMore: false,
    launch: "// TODO",
    toggle: false,
    expanded: false,
    type: "panel",
    autoShow: false,
    enabled: isEnabled,
    hideInMobile: true,
    sidebar: {
      icon: "/img/pearson-st/pearson-logo.svg",
      activeMethod: "fill", // 'fill' or 'highlight'
      action: launchPearsonSmartThinking
    }
  })
};
